// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eP6FO{position:absolute;gap:6px;padding:16px 19px;align-items:center}.SGllI{width:26px;height:26px}`, "",{"version":3,"sources":["webpack://./src/components/bubble/Bubble.module.scss"],"names":[],"mappings":"AAAA,OACE,iBAAA,CACA,OAAA,CACA,iBAAA,CACA,kBAAA,CAGF,OACE,UAAA,CACA,WAAA","sourcesContent":[".container {\n  position: absolute;\n  gap: 6px;\n  padding: 16px 19px;\n  align-items: center;\n}\n\n.iconWrapper {\n  width: 26px;\n  height: 26px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `eP6FO`,
	"iconWrapper": `SGllI`
};
export default ___CSS_LOADER_EXPORT___;
